export type QuizGradeOutcome = "correct" | "partial" | "incorrect";
export type QuizGradeMethod = "exact" | "fuzzy" | "structural" | "llm";

export interface QuizGradePart {
	key: string;
	outcome: QuizGradeOutcome;
	score: number;
}

export interface QuizGradeFeedback {
	summary: string;
	rationale?: string;
}

export interface QuizGradeResult {
	outcome: QuizGradeOutcome;
	score: number;
	method: QuizGradeMethod;
	parts?: QuizGradePart[];
	feedback?: QuizGradeFeedback;
	matchedAnswerId: string | null;
}

/** Clamp to [0, 1] then map: 1 → correct, 0 → incorrect, else partial. */
export function outcomeFromScore(score: number): QuizGradeOutcome {
	const clamped = clampUnitInterval(score);
	if (clamped === 1) {
		return "correct";
	}
	if (clamped === 0) {
		return "incorrect";
	}
	return "partial";
}

export function clampUnitInterval(score: number): number {
	if (!Number.isFinite(score)) {
		return 0;
	}
	if (score <= 0) {
		return 0;
	}
	if (score >= 1) {
		return 1;
	}
	return score;
}

export function quizGradeResultFromScore(params: {
	score: number;
	method: QuizGradeMethod;
	matchedAnswerId?: string | null;
	parts?: QuizGradePart[];
	feedback?: QuizGradeFeedback;
}): QuizGradeResult {
	const score = clampUnitInterval(params.score);
	return {
		outcome: outcomeFromScore(score),
		score,
		method: params.method,
		matchedAnswerId: params.matchedAnswerId ?? null,
		...(params.parts ? { parts: params.parts } : {}),
		...(params.feedback ? { feedback: params.feedback } : {}),
	};
}
